export default __webpack_public_path__ + "static/media/Sai_Teja_Bhoomraogari_CV.f254b958.pdf";